import { MatchCollection } from '../models/match-collection.model';
import { Match } from '../models/match.model';

const seeding = (numPlayers: number) => {
  // TODO: Throw error if not sequence of 2
  // TODO: Unit test this
  const nextLayer = (players: number[]) => {
    const out = [];
    const length = players.length * 2 + 1;
    players.forEach((d: number) => {
      out.push(d);
      out.push(length - d);
    });
    return out;
  };

  const rounds = Math.log(numPlayers) / Math.log(2) - 1;
  let roundPlayers = [1, 2];
  for (let i = 0; i < rounds; i++) {
    roundPlayers = nextLayer(roundPlayers);
  }
  return roundPlayers;
};

export const sortMatchesBySeeding = (
  capacityRoundSlots: number,
  playInMatches: MatchCollection,
  capacityMatches: MatchCollection
): { capacityMatches: Match[]; playInMatches: Match[] } => {
  const desiredSeedingOrder = seeding(capacityRoundSlots);

  // Desired seeing is the seeding for the capacity round.
  // If 8 teams exist, desired seeding would be [1, 8, 4, 5, 2, 7, 3, 6]

  const sorted = {
    capacityMatches: [],
    playInMatches: [],
  };

  for (let i = 0; i < desiredSeedingOrder.length; i += 2) {
    const matchWithSeed = capacityMatches.findMatchWithSeed(
      desiredSeedingOrder[i]
    );

    if (matchWithSeed) {
      sorted.capacityMatches.push(matchWithSeed);
    } else {
      const playInGame = playInMatches.findMatchWithSeed(
        desiredSeedingOrder[i]
      );
      const coorCapGame = capacityMatches.findByWinnerSlot(playInGame);
      sorted.capacityMatches.push(coorCapGame);
    }
  }

  sorted.playInMatches = playInMatches.toArray();

  return sorted;
};
